import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { useTenant } from '@/hooks/useTenant';

interface TimezoneContextType {
  timezone: string;
  isLoading: boolean;
}

const DEFAULT_TIMEZONE = 'Australia/Sydney';

const TimezoneContext = createContext<TimezoneContextType>({
  timezone: DEFAULT_TIMEZONE,
  isLoading: true,
});

export function TimezoneProvider({ children }: { children: ReactNode }) {
  const { company, isLoadingCompany } = useTenant();

  const timezone = company?.timezone || DEFAULT_TIMEZONE;
  const value = useMemo(() => ({ timezone, isLoading: isLoadingCompany }), [timezone, isLoadingCompany]);

  return (
    <TimezoneContext.Provider value={value}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  return useContext(TimezoneContext);
}

export { DEFAULT_TIMEZONE };
